let init = false;

class Tooltip {
    constructor() {
        if (init) {
            return;
        }

        init = true;

        let $tooltip = $('<span class="tooltip hide"><span class="tooltip-arrow"></span><span class="tooltip-content"></span></span>'); 

        $('body').append($tooltip); 

        $('body').on('mouseover', '[data-tooltip]', function(event) {
            event.stopPropagation();   

            const $this = $(this); 
            const $tooltipContent = $tooltip.find('.tooltip-content');
            const text = $this.attr('data-tooltip'); 

            $tooltipContent.text(text.substring(0, 150));

            $tooltip.removeClass('hide'); 
            
            // Make it position: fixed 
            // to get accurate width of the tooltip 
            // before calculating top, left values 
            $tooltip[0].style.position = 'fixed'; 
            $tooltip[0].style.visiblity = 'hidden';
            $tooltip[0].style.left = '-100000px';

            const width = $tooltip[0].offsetWidth; 
            const height = $tooltip[0].offsetHeight;

            $tooltip[0].style.removeProperty('position'); 
            $tooltip[0].style.removeProperty('visiblity'); 
            $tooltip[0].style.removeProperty('left'); 
 
            const $tooltipArrow = $tooltip.find('.tooltip-arrow'); 

            const rect = this.getBoundingClientRect();

            const offsetEdge = 7;
            const top = rect.y + document.documentElement.scrollTop - height - offsetEdge;
            let left = rect.left - (width / 2) + ($this.outerWidth() / 2); 
            let right;
            let adjusted = 0;

            // Use cases 
            // horizontally 
            // tooltip is out from left viewport edge   
            if (left < offsetEdge) {
                adjusted = Math.abs(left) + offsetEdge;
                left = offsetEdge;
            } 

            // tooltip is out from right viewport edge  
            if (left + width > window.innerWidth) {
                adjusted = window.innerWidth - (left + width + offsetEdge); 
                left = window.innerWidth - width - offsetEdge; 
            } 

            // tooltip is larger than the entire viewport 
            if ((width + (offsetEdge * 2)) > window.innerWidth) {
                left = offsetEdge;
                right = offsetEdge;
            }

            $tooltip.css({
                top: `${top}px`,
                left: `${left}px`,

                ...(right !== undefined && { right: `${right}px` })
            });

            $tooltipArrow.css({
                left: `calc(50% - ${adjusted}px)`
            });
        });

        $('body').on('mouseout', '[data-tooltip]', function() {
            $tooltip.find('.tooltip-content').text(''); 
            $tooltip.addClass('hide');
        });
    }
}

export { Tooltip };
